import { StarIcon } from '@heroicons/react/24/solid'
import clsx from 'clsx'

function Rating({ rating, size = 'sm' }: { rating: number; size?: 'sm' | 'lg' }) {
  const starSize = size === 'lg' ? 'h-7 w-7' : 'h-5 w-5'

  return (
    <div className="flex items-center gap-1">
      {[1, 2, 3, 4, 5].map((step) => (
        <StarIcon
          key={step}
          className={clsx(
            rating >= step ? 'text-primary' : 'text-white/20',
            starSize,
            'flex-shrink-0',
          )}
          aria-hidden="true"
        />
      ))}
    </div>
  )
}

export default Rating
